export default "__VITE_ASSET__D_oK1xdy__"